const store = {
  classifications: {
    byApplication: {}
  },
  documents: {
    byApplication: {}
  },
  comments: {
    byApplication: {}
  },
  DRAFT_TEMPLATE_NAME: "",
  documentRequestLists: {
    byId: {},
    allIds: []
  },
  documentRequests: {
    byId: {}
  },
  sampleDocuments: {
    byId: {}
  },
  documentRequestTemplates: {
    byId: {},
    allIds: []
  },
  markedDocumentClassifications: {},
  documentTypes: {
    byId: {},
    allIds: []
  },
  labels: {
    userLabels: {
      allIds: [],
      byId: {}
    },
    brokerageLabels: {
      allIds: [],
      byId: {}
    }
  },
  extractedDocumentValues: {
    byId: {},
    allIds: []
  }
};
export default store;